<template>
  <div class="quantity">
    <a @click.prevent="setQuantity(+quan-(+step))" class="quantity__link quantity__link-minus" href="#"></a>
    <div class="quantity__control">
      <input class="quantity__control-input" v-model.lazy="quan" :readonly="readonly" type="text" />
      <div class="quantity__control-text">{{ measureName }}</div>
    </div>
    <a @click.prevent="setQuantity(+quan+ (+step))" class="quantity__link quantity__link-plus" href="#"></a>
  </div>
</template>

<script>
export default {
  name: 'Quantity',
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 1,
    },
    // min: {
    //   type: Number,
    //   default: 1,
    // },
    max: {
      type: Number,
      default: 9999,
    },
    step: {
      type: Number,
      default: 1,
    },
    measureName: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    quan: 1,
  }),
  watch: {
    value( val )
    {
      this.quan = val;
    },
    quan( val )
    {
      this.setQuantity( val );
      this.$emit( 'input', val );
    },
  },
  computed: {
    min()
    {
      return this.step;
    }
  },
  mounted()
  {
    this.quan = this.step || 1;
  },
  methods: {
    setQuantity( quantity )
    {
      quantity = Math.round(quantity*100) / 100;
      if ( quantity < this.min )
      {
            quantity = this.min;
      }
      if ( quantity > this.max )
      {
        quantity = this.max;
      }
      if ( quantity != this.quan )
      {
        this.quan = quantity;
      }
    },
  },
}
</script>
